import React, { useState } from "react";
import "./ChecksheetApar.css";
import { useChecksheetApar } from "./useChecksheetApar";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import { apar, mock } from "../../util/constant";
import { today } from "../../util/formatDate";
import AccordionApar from "../../components/AccordionApar/AccordionApar";
import Apar1 from "../../Assets/APAR-1.png";
import Apar2 from "../../Assets/APAR-2.png";
import Parkiran from "../../Assets/PARKIRAN.png";
import SatuSetengah from "../../Assets/SATU-SETENGAH.png";
import Basement from "../../Assets/BASEMENT.png";
import AparIcon from "../../Assets/fire-icon.png";
import moment from "moment";

const points = [
  { id: "1", style: { top: "72%", left: "6%" } },
  { id: "2", style: { top: "62%", left: "14%" } },
  { id: "3", style: { top: "72%", left: "14%" } },
  { id: "4", style: { top: "61%", left: "30%" } },
  { id: "5", style: { top: "71%", left: "29%" } },
  { id: "6", style: { top: "81%", left: "30%" } },
  { id: "7", style: { top: "80%", left: "47%" } },
  { id: "8", style: { top: "62%", left: "46.8%" } },
  { id: "9", style: { top: "80%", left: "55%" } },
  { id: "10", style: { top: "64%", left: "61.5%" } },
  { id: "11", style: { top: "80%", left: "71%" } },
  { id: "12", style: { top: "64%", left: "71%" } },
  { id: "13", style: { top: "41%", left: "74%" } },
  { id: "14", style: { top: "17%", left: "75%" } },
  { id: "15", style: { top: "18%", left: "69%" } },
  { id: "16", style: { top: "19%", left: "56%" } },
  { id: "17", style: { top: "19%", left: "49%" } },
  { id: "18", style: { top: "28%", left: "43%" } },
  { id: "19", style: { top: "47%", left: "47%" } },
  { id: "20", style: { top: "42%", left: "58%" } },
  { id: "21", style: { top: "55%", left: "67%" } },
  { id: "22", style: { top: "77%", left: "15%" } },
  { id: "23", style: { top: "76%", left: "54%" } },
  { id: "24", style: { top: "76%", left: "76%" } },
  { id: "25", style: { top: "14%", left: "85%" } },
  { id: "26", style: { top: "53.8%", left: "84%" } },
  { id: "27", style: { top: "56%", left: "72%" } },
  { id: "28", style: { top: "57%", left: "61%" } },
  { id: "29", style: { top: "23%", left: "71%" } },
  { id: "30", style: { top: "75%", left: "86%" } },
  { id: "31", style: { top: "14%", left: "90%" } },
  { id: "32", style: { top: "61%", left: "24.5%" } },
  { id: "33", style: { top: "7%", left: "21%" } },
  { id: "34", style: { top: "7%", left: "36%" } },
  { id: "35", style: { top: "20%", left: "36%" } },
  { id: "36", style: { top: "34%", left: "36%" } },
  { id: "37", style: { top: "48%", left: "36%" } },
  { id: "38", style: { top: "62%", left: "36%" } },
  { id: "39", style: { top: "79%", left: "33%" } },
  { id: "40", style: { top: "13%", left: "92%" } },
  { id: "41", style: { top: "26%", left: "92%" } },
  { id: "42", style: { top: "38%", left: "92%" } },
  { id: "43", style: { top: "50%", left: "92%" } },
  { id: "44", style: { top: "62%", left: "90%" } },
  { id: "45", style: { top: "64%", left: "21%" } },
  { id: "46", style: { top: "53%", left: "21%" } },
  { id: "47", style: { top: "41%", left: "21%" } },
  { id: "48", style: { top: "18%", left: "21%" } },
  { id: "49", style: { top: "18%", left: "14%" } },
  { id: "50", style: { top: "29%", left: "21%" } },
  { id: "51", style: { top: "88%", left: "21%" } },
  { id: "52", style: { top: "88%", left: "41%" } },
  { id: "53", style: { top: "34%", left: "49%" } },
  { id: "54", style: { top: "89.5%", left: "69%" } },
  { id: "55", style: { top: "37%", left: "62%" } },
  { id: "56", style: { top: "75%", left: "31%" } },
  { id: "57", style: { top: "91%", left: "66%" } },
  { id: "58", style: { top: "38%", left: "92%" } },
  { id: "59", style: { top: "19%", left: "81%" } },
];

const ChecksheetApar = () => {
  const {
    dateApar,
    setDateApar,
    supplier,
    setSupplier,
    kondisi,
    setKondisi,
    checkListIncomingApar,
    handleChangeIncomingApar,
    popUpKirimChecklist,
    handleCloseScan,
    type,
    setType,
    keterangan,
    setKeterangan,
    subMenu,
    setSubMenu,
    checkListApar,
    handleChangeChecksheetApar,
    popUpChecksheet,
    setPopUpChecksheet,
    filterMesin,
    setFilterMesin,
    filterType,
    setFilterType,
    dataTemp,
    kadaluarsa,
    setKadaluarsa,
    tanggalKadaluarsa,
    errorMsg,
    setErrorMsg,
    handleKirimInOut,
    listApar,
    listStatusApar,
    filterLantai,
    setFilterLantai,
    sortApar,
    setSortApar,
  } = useChecksheetApar();

  const [openItemId, setOpenItemId] = useState(null);

  const toggleItem = (itemId) => {
    setOpenItemId(openItemId === itemId ? null : itemId);
  };

  const pilihJenis = (jenis) => {
    setType(jenis);
    setErrorMsg("");
  };

  let listDataMap = [];

  listStatusApar &&
    listStatusApar.forEach((element) => {
      const foundObject = points.find((item) => item.id === element.noApar);
      if (foundObject) {
        listDataMap.push({
          ...foundObject,
          incoming: element.incoming,
          kadaluarsa: element.kadaluarsa,
          isKeluar: element.isKeluar,
          isNotif: element.isNotif,
          isTrouble: element.isTrouble,
          jenis: element.jenis,
          lantai: element.lantai,
          lastChecked: element.lastChecked,
          lastCheckedBy: element.lastCheckedBy,
          lastUsage: element.lastUsage,
          name: element.name,
        });
      }
    });

  return (
    <div className="container_dashboard">
      {popUpKirimChecklist ? (
        <PopUpComponent>
          <div id="qr" style={{ marginBottom: "12px" }}></div>
          <button onClick={() => handleCloseScan()}>Tutup</button>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpChecksheet ? (
        <PopUpComponent>
          <div id="qr-checksheet" style={{ marginBottom: "12px" }}></div>
          <button
            onClick={() => {
              handleCloseScan();
              setPopUpChecksheet(false);
            }}
          >
            Tutup
          </button>
        </PopUpComponent>
      ) : (
        ""
      )}

      <div className="wrapper_sub_menu_history" style={{ marginBottom: "0" }}>
        <p
          className={
            subMenu === "monitoring"
              ? "sub_menu_history border_active_history"
              : "sub_menu_history"
          }
          onClick={() => setSubMenu("monitoring")}
        >
          Monitoring
        </p>
        <p
          className={
            subMenu === "Riwayat"
              ? "sub_menu_history border_active_history"
              : "sub_menu_history"
          }
          onClick={() => setSubMenu("Riwayat")}
        >
          Riwayat
        </p>
        <p
          className={
            subMenu === "Checksheet"
              ? "sub_menu_history border_active_history"
              : "sub_menu_history"
          }
          onClick={() => setSubMenu("Checksheet")}
        >
          Checksheet
        </p>
        <p
          className={
            subMenu === "InOut"
              ? "sub_menu_history border_active_history"
              : "sub_menu_history"
          }
          onClick={() => setSubMenu("InOut")}
        >
          In / Out
        </p>
        <p
          className={
            subMenu === "Inventory"
              ? "sub_menu_history border_active_history"
              : "sub_menu_history"
          }
          onClick={() => setSubMenu("Inventory")}
        >
          Inventory
        </p>
      </div>

      {subMenu === "Checksheet" ? (
        <div>
          <div style={{ width: "100%", overflow: "auto" }}>
            <table>
              <thead>
                <tr>
                  <th className="th-checksheet-apar">No.</th>
                  <th className="th-checksheet-apar">Item Check</th>
                  <th className="th-checksheet-apar">Standar</th>
                  <th className="th-checksheet-apar">Checklist</th>
                </tr>
              </thead>
              <tbody>
                {checkListApar &&
                  checkListApar.map((data, index) => (
                    <tr
                      key={index}
                      style={{
                        background: index % 2 === 0 ? "white" : "#f2f2f2",
                      }}
                    >
                      <td className="td-checksheet-apar">{index + 1}.</td>
                      <td
                        className="td-checksheet-apar"
                        style={{ textAlign: "left" }}
                      >
                        {data.itemCheck}
                      </td>
                      <td
                        className="td-checksheet-apar"
                        style={{ textAlign: "left", fontStyle: "italic" }}
                      >
                        {data.standar}
                      </td>
                      {index === 12 ? (
                        <td className="td-checksheet-apar">
                          <input
                            type="number"
                            name="beratTabungApar"
                            style={{ width: "56px", height: "24px" }}
                            placeholder="Kg"
                            value={
                              data.beratTabungApar ? data.beratTabungApar : ""
                            }
                            onChange={(e) =>
                              handleChangeChecksheetApar(index, e)
                            }
                          />
                        </td>
                      ) : (
                        <td className="td-checksheet-apar">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <input
                              type="checkbox"
                              className="checkbox-normal"
                              name="isStandard"
                              checked={data.isStadard}
                              onChange={(e) =>
                                handleChangeChecksheetApar(index, e)
                              }
                            />
                            <input
                              className="cross-checkbox"
                              type="checkbox"
                              name="isTidakStandard"
                              checked={data.isTidakStandard}
                              onChange={(e) =>
                                handleChangeChecksheetApar(index, e)
                              }
                            />
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "end" }}>
            <button
              className="button-kirim-apar"
              onClick={() => setPopUpChecksheet(true)}
            >
              Kirim
            </button>
          </div>
        </div>
      ) : subMenu === "InOut" ? (
        <>
          <div className="form-inout">
            <div className="form-group">
              <p className="form-label">Tanggal In/Out</p>
              <input
                type="date"
                value={dateApar}
                onChange={(e) => setDateApar(e.target.value)}
              />
            </div>

            <div className="form-group">
              <p className="form-label">Jenis</p>
              <div style={{ display: "flex", gap: "12px" }}>
                <div
                  className="flex-align-center"
                  onClick={() => pilihJenis("Incoming")}
                >
                  <input
                    type="radio"
                    value="Incoming"
                    checked={type === "Incoming"}
                    readOnly
                  />
                  <label>Incoming</label>
                </div>
                <div
                  className="flex-align-center"
                  onClick={() => pilihJenis("Pemakaian")}
                >
                  <input
                    type="radio"
                    value="Pemakaian"
                    checked={type === "Pemakaian"}
                    readOnly
                  />
                  <label>Pemakaian</label>
                </div>
                <div
                  className="flex-align-center"
                  onClick={() => pilihJenis("Keluar")}
                >
                  <input
                    type="radio"
                    value="Keluar"
                    checked={type === "Keluar"}
                    readOnly
                  />
                  <label>Keluar</label>
                </div>
              </div>
            </div>

            {type === "Incoming" ? (
              <div className="form-group">
                <p className="form-label">Supplier</p>
                <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                  <input
                    type="text"
                    placeholder="Supplier"
                    value={supplier || ""}
                    onChange={(e) => setSupplier(e.target.value)}
                  />
                  <div
                    className="flex-align-center"
                    onClick={() => setKondisi("Baru")}
                  >
                    <input
                      type="radio"
                      value="Baru"
                      checked={kondisi === "Baru"}
                      readOnly
                    />
                    <label>Baru</label>
                  </div>
                  <div
                    className="flex-align-center"
                    onClick={() => setKondisi("Isi Ulang")}
                  >
                    <input
                      type="radio"
                      value="Isi Ulang"
                      checked={kondisi === "Isi Ulang"}
                      readOnly
                    />
                    <label>Isi Ulang</label>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {type === "Incoming" ? (
              <div className="form-group">
                <p className="form-label">Tanggal Kadaluarsa</p>
                <div className="flex-align-center" style={{ gap: "6px" }}>
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength={2}
                    placeholder="Tgl"
                    style={{ width: "48px", textAlign: "center" }}
                    value={kadaluarsa.tgl}
                    onChange={(e) => {
                      setKadaluarsa({
                        ...kadaluarsa,
                        tgl: e.target.value.replace(/\D/g, ""),
                      });
                      setErrorMsg("");
                    }}
                  />
                  <span>/</span>
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength={2}
                    placeholder="Bln"
                    style={{ width: "48px", textAlign: "center" }}
                    value={kadaluarsa.bln}
                    onChange={(e) => {
                      setKadaluarsa({
                        ...kadaluarsa,
                        bln: e.target.value.replace(/\D/g, ""),
                      });
                      setErrorMsg("");
                    }}
                  />
                  <span>/</span>
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength={4}
                    placeholder="Tahun"
                    style={{ width: "72px", textAlign: "center" }}
                    value={kadaluarsa.thn}
                    onChange={(e) => {
                      setKadaluarsa({
                        ...kadaluarsa,
                        thn: e.target.value.replace(/\D/g, ""),
                      });
                      setErrorMsg("");
                    }}
                  />
                </div>
                {tanggalKadaluarsa && (
                  <small className="info-kadaluarsa">
                    Kadaluarsa: {moment(tanggalKadaluarsa).format("DD-MM-YYYY")}
                  </small>
                )}
              </div>
            ) : (
              ""
            )}

            {type === "Pemakaian" || type === "Keluar" ? (
              <div className="form-group">
                <p className="form-label">Keterangan</p>
                <input
                  type="text"
                  placeholder="Keterangan"
                  value={keterangan || ""}
                  onChange={(e) => setKeterangan(e.target.value.toUpperCase())}
                />
              </div>
            ) : (
              ""
            )}
          </div>

          {type === "Incoming" ? (
            <div style={{ width: "100%", overflow: "auto" }}>
              <table>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Poin Cek</th>
                    <th>Standard</th>
                    <th>Hasil Cek</th>
                  </tr>
                </thead>
                <tbody>
                  {checkListIncomingApar &&
                    checkListIncomingApar.map((data, index) => {
                      return (
                        <tr
                          key={index}
                          style={{
                            background: index % 2 === 0 ? "white" : "#f2f2f2",
                          }}
                        >
                          <td>{index + 1}.</td>
                          <td>{data.itemCheck}</td>
                          <td>{data.standar}</td>
                          {index === 7 ? (
                            <td>
                              <input
                                type="number"
                                name="beratTabungApar"
                                style={{ width: "56px", height: "24px" }}
                                placeholder="Kg"
                                value={
                                  data.beratTabungApar
                                    ? data.beratTabungApar
                                    : ""
                                }
                                onChange={(e) =>
                                  handleChangeIncomingApar(index, e)
                                }
                              />
                            </td>
                          ) : index === 8 ? (
                            <td>
                              <input
                                type="number"
                                style={{ width: "56px", height: "24px" }}
                                placeholder="Kg"
                                value={
                                  data.beratIsiApar ? data.beratIsiApar : ""
                                }
                                name="beratIsiApar"
                                onChange={(e) =>
                                  handleChangeIncomingApar(index, e)
                                }
                              />
                            </td>
                          ) : (
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  className="checkbox-normal"
                                  name="isStandard"
                                  checked={data.isStadard}
                                  onChange={(e) =>
                                    handleChangeIncomingApar(index, e)
                                  }
                                />
                                <input
                                  className="cross-checkbox"
                                  type="checkbox"
                                  name="isTidakStandard"
                                  checked={data.isTidakStandard}
                                  onChange={(e) =>
                                    handleChangeIncomingApar(index, e)
                                  }
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          ) : (
            ""
          )}

          {errorMsg && <div className="error-message">{errorMsg}</div>}

          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "12px",
            }}
          >
            <button className="button-kirim-apar" onClick={handleKirimInOut}>
              Kirim
            </button>
          </div>
        </>
      ) : subMenu === "Riwayat" ? (
        <>
          <div className="filter-bar">
            <input
              type="date"
              value={dateApar}
              onChange={(e) => setDateApar(e.target.value)}
            />
            <select
              style={{ minWidth: "90px" }}
              value={filterMesin}
              onChange={(e) => setFilterMesin(e.target.value)}
            >
              <option disabled>Pilih Apar</option>
              {apar.map((ele) => (
                <option key={ele} value={ele}>
                  {ele}
                </option>
              ))}
            </select>
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
            >
              <option disabled>Pilih Jenis</option>
              <option value="Checksheet">Checksheet</option>
              <option value="InOut">IN OUT</option>
            </select>
            <select
              value={sortApar}
              onChange={(e) => setSortApar(e.target.value)}
            >
              <option value="asc">No. APAR: A-Z</option>
              <option value="desc">No. APAR: Z-A</option>
            </select>
            <button
              className="button-kirim-apar"
              style={{ background: "#81bfda" }}
              onClick={() => {
                setFilterType("Checksheet");
                setFilterMesin("Pilih Apar");
                setDateApar(today);
              }}
            >
              Reset
            </button>
          </div>
          {dataTemp &&
            dataTemp.map((ele) => {
              return (
                <AccordionApar
                  key={ele._id || ele.noApar}
                  data={ele}
                  mock={mock}
                  isOpen={openItemId === ele.noApar}
                  onClick={() => toggleItem(ele.noApar)}
                />
              );
            })}
        </>
      ) : subMenu === "monitoring" ? (
        <>
          <select
            style={{ padding: "6px", marginTop: "12px" }}
            value={filterLantai}
            onChange={(e) => setFilterLantai(e.target.value)}
          >
            <option value={"1"}>Lantai 1</option>
            <option value={"SATU SETENGAH"}>Lantai 1 Setengah</option>
            <option value={"2"}>Lantai 2</option>
            <option value={"BASEMENT"}>Basement</option>
            <option value={"PARKIRAN"}>Parkiran</option>
          </select>
          <div className="apar-wrapper">
            <img
              src={
                filterLantai === "1"
                  ? Apar1
                  : filterLantai === "SATU SETENGAH"
                  ? SatuSetengah
                  : filterLantai === "2"
                  ? Apar2
                  : filterLantai === "BASEMENT"
                  ? Basement
                  : filterLantai === "PARKIRAN"
                  ? Parkiran
                  : ""
              }
              alt="Denah APAR"
              style={{ width: "100%", display: "block" }}
            />
            {listDataMap.map((p, i) => {
              const now = moment().utcOffset("+0700");
              const tglKadaluarsa = moment(p.kadaluarsa).utcOffset("+0700");
              const validateKadaluarsa = tglKadaluarsa.isSameOrBefore(now);
              const validateThirtyDays = tglKadaluarsa
                .clone()
                .add(-31, "days")
                .isSameOrBefore(now);

              return (
                <div className="apar" key={i} style={p.style}>
                  <img
                    src={AparIcon}
                    alt={`APAR ${p.id}`}
                    className={
                      (p.isKeluar || p.isTrouble) && !validateKadaluarsa
                        ? "apar-icon-isTrouble"
                        : validateKadaluarsa
                        ? "apar-icon-inactive"
                        : validateThirtyDays
                        ? "apar-icon-thirty-days"
                        : "apar-icon-active"
                    }
                  />
                  <div className="popup">
                    APAR No: <b>{p.id}</b>
                    <br />
                    Jenis: {p.jenis}
                    <br />
                    Diperiksa:{" "}
                    {p.lastChecked
                      ? moment(p.lastChecked)
                          .utcOffset("+0700")
                          .format("DD-MM-YYYY")
                      : ""}{" "}
                    -{" "}
                    <b>
                      {p.lastCheckedBy
                        ? p.lastCheckedBy
                            .match(/(\b\S)?/g)
                            .join("")
                            .toUpperCase()
                        : ""}
                    </b>
                    <br />
                    <span
                      style={validateKadaluarsa ? { color: "#ff6b6b" } : {}}
                    >
                      Kadaluarsa: {tglKadaluarsa.format("DD-MM-YYYY")}
                    </span>
                    <br />
                    <span
                      style={p.isKeluar ? { color: "rgb(255, 221, 0)" } : {}}
                    >
                      Keluar: {p.isKeluar ? "YES" : "NO"}
                    </span>
                    <br />
                    <span style={p.isTrouble ? { color: "#ff6b6b" } : {}}>
                      Trouble: {p.isTrouble ? "YES" : "NO"}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : subMenu === "Inventory" ? (
        <div style={{ width: "100%", overflow: "auto" }}>
          <div className="filter-bar">
            <select
              value={sortApar}
              onChange={(e) => setSortApar(e.target.value)}
            >
              <option value="asc">No. APAR: A-Z</option>
              <option value="desc">No. APAR: Z-A</option>
            </select>
          </div>
          <table>
            <thead>
              <tr>
                <th>APAR</th>
                <th>Jenis</th>
                <th>Status</th>
                <th>Lantai</th>
                <th>Kadaluarsa</th>
                <th>Last Check</th>
                <th>Petugas</th>
              </tr>
            </thead>
            <tbody>
              {listApar &&
                listApar.map((data, index) => {
                  const now = moment().utcOffset("+0700");
                  const tglKadaluarsa = moment(data.kadaluarsa).utcOffset(
                    "+0700"
                  );
                  const validateKadaluarsa = tglKadaluarsa.isSameOrBefore(now);
                  const validateThirtyDays = tglKadaluarsa
                    .clone()
                    .add(-31, "days")
                    .isSameOrBefore(now);

                  return (
                    <tr
                      key={index}
                      style={{
                        background: index % 2 === 0 ? "white" : "#f2f2f2",
                        fontSize: "12px",
                      }}
                    >
                      <td style={{ textAlign: "center" }}>{data.noApar}.</td>
                      <td>{data.jenis}</td>
                      <td>{data.isKeluar ? "KELUAR" : "AKTIF"}</td>
                      <td>{data.lantai}</td>
                      <td
                        style={
                          validateKadaluarsa
                            ? { background: "red" }
                            : validateThirtyDays
                            ? { background: "yellow" }
                            : { background: "lightgreen" }
                        }
                      >
                        {tglKadaluarsa.format("DD-MM-YYYY")}
                      </td>
                      <td>
                        {data.lastChecked
                          ? moment(data.lastChecked)
                              .utcOffset("+0700")
                              .format("DD-MM-YYYY")
                          : ""}
                      </td>
                      <td>{data.lastCheckedBy}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ChecksheetApar;
